import styled from 'styled-components';
import { LineBordered as BorderedLine } from 'app/components';

export const BonusCardSection = styled.div.attrs({
  className: 'bonuscard-ticket'
})`
  h3 {
    font-weight: 420;
    font-size: 18px;
    line-height: 24px;
  }
  .bonuscard-ticket__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid #323232;
  }
  .bonuscard-ticket__credit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid #323232;
  }
  .bonuscard-ticket__fetch {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid #323232;
    color: #888888;
    
    h3 {
      font-weight: 390;
    }
  }
`;

export default styled(BorderedLine)`
  font-size: 1.8rem;
  line-height: 1.33;

  .text-accent {
    color: ${({ theme }) => theme.color.accent};
  }

  a {
    flex-shrink: 0;
    min-width: auto;
    cursor: pointer;
  }
`;
